<div fxLayout="row">
    <mat-label>
        <mat-icon>error</mat-icon>
        <div class="user-info-content">
            <ng-content></ng-content>
        </div>
    </mat-label>
</div>
